module.exports = __webpack_public_path__ + "img/6.88aa897f.png";